<template>
    <v-container>
        <v-card color="basil">

            <v-tabs v-model="tab"
                    background-color="transparent"
                    grow>
                <v-tab v-for="item in items"
                       :key="item.id">
                    {{ item }}
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items"
                            :key="item.id">

                    <v-progress-linear indeterminate
                                       v-if="isBusy"
                                       color="primary"></v-progress-linear>

                    <div v-if="item === 'My Charts'">

                        <v-text-field v-model="myChartSearchText"
                                      append-icon="mdi-magnify"
                                      label="Search"
                                      single-line
                                      class="ma-6"
                                      hide-details></v-text-field>


                        <div v-if="myChartTotalPages === 0" class="w-100 text-center text-subtitle-1 ma-3">
                            No charts found
                        </div>

                        <v-row class="ma-4">

                            <v-col cols="12" md="4" xs="4" v-for="chart in myCharts" :key="chart">
                                <v-card class="pa-1" elevation="5">
                                    <v-row>
                                        <v-col cols="12" md="1" xs="1">
                                            <v-icon class="mt-3 ml-3" large v-if="chart.type === 'LINE'">mdi-chart-line</v-icon>
                                            <v-icon class="mt-3 ml-3" large v-if="chart.type === 'PIE'">mdi-chart-arc</v-icon>
                                            <v-icon class="mt-3 ml-3" large v-if="chart.type === 'WORDCLOUD'">mdi-alpha-w-box</v-icon>
                                            <v-icon class="mt-3 ml-3" large v-if="chart.type === 'TABLE'">mdi-table</v-icon>
                                        </v-col>
                                        <v-col cols="12" md="9" xs="9">
                                            <v-card-title class="text-subtitle-1 mb-1">{{chart.title}}</v-card-title>
                                        </v-col>
                                        <v-col ols="12" md="2" xs="2">
                                            <div class="w-100 text-right">
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-bind="attrs"
                                                                v-on="on">
                                                            mdi-dots-horizontal
                                                        </v-icon>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item-group>
                                                            <v-list-item v-f="isAdmin">
                                                                <v-list-item-title @click="editChart(chart)">Edit</v-list-item-title>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-title @click="cloneChart(chart)">Clone</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list-item-group>
                                                    </v-list>
                                                </v-menu>
                                            </div>
                                        </v-col>
                                    </v-row>



                                    <v-chip class="ma-2 text-right" label v-if="chart.type === 'LINE'"
                                            color="primary">
                                        <v-icon left>
                                            mdi-chart-line
                                        </v-icon> {{chart.type}}
                                    </v-chip>

                                    <v-chip class="ma-2 text-right" label v-if="chart.type === 'WORDCLOUD'"
                                            color="green">
                                        <v-icon left>
                                            mdi-alpha-w-box
                                        </v-icon>{{chart.type}}
                                    </v-chip>

                                    <v-chip class="ma-2 text-right" label v-if="chart.type === 'PIE'"
                                            color="red">
                                        <v-icon left>
                                            mdi-chart-arc
                                        </v-icon>{{chart.type}}
                                    </v-chip>

                                    <v-chip class="ma-2 text-right" label v-if="chart.type === 'TABLE'"
                                            color="default">
                                        <v-icon left>
                                            mdi-table
                                        </v-icon> {{chart.type}}
                                    </v-chip>


                                </v-card>
                            </v-col>
                        </v-row>

                        <div class="text-center pb-3" v-if="myChartTotalPages > 0">
                            <v-pagination v-model="myChartPageNo"
                                          :length="myChartTotalPages"
                                          circle></v-pagination>
                        </div>

                    </div>
                    <div v-if="item === 'Template Charts'">

                        <v-text-field v-model="templateChartSearchText"
                                      append-icon="mdi-magnify"
                                      label="Search"
                                      single-line
                                      class="ma-6"
                                      hide-details></v-text-field>


                        <div v-if="templateChartTotalPages === 0" class="w-100 text-center text-subtitle-1 ma-3">
                            No charts found
                        </div>

                        <v-row class="ma-4">
                            <v-col cols="12" md="4" xs="4" v-for="chart in templateCharts" :key="chart.id">
                                <v-card class="pa-1" elevation="5">
                                    <v-row>
                                        <v-col cols="12" md="1" xs="1">
                                            <v-icon class="mt-3 ml-3" large v-if="chart.type === 'LINE'">mdi-chart-line</v-icon>
                                            <v-icon class="mt-3 ml-3" large v-if="chart.type === 'PIE'">mdi-chart-arc</v-icon>
                                            <v-icon class="mt-3 ml-3" large v-if="chart.type === 'WORDCLOUD'">mdi-alpha-w-box</v-icon>
                                            <v-icon class="mt-3 ml-3" large v-if="chart.type === 'TABLE'">mdi-table</v-icon>
                                        </v-col>
                                        <v-col cols="12" md="9" xs="9">
                                            <v-card-title class="text-subtitle-1 mb-1">{{chart.title}}</v-card-title>
                                        </v-col>
                                        <v-col ols="12" md="2" xs="2">
                                            <div class="w-100 text-right">
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon v-bind="attrs"
                                                                v-on="on">
                                                            mdi-dots-horizontal
                                                        </v-icon>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item-group>
                                                            <v-list-item v-if="isAdmin">
                                                                <v-list-item-title @click="editChart(chart)">Edit</v-list-item-title>
                                                            </v-list-item>
                                                            <v-list-item>
                                                                <v-list-item-title @click="cloneChart(chart)">Clone</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list-item-group>
                                                    </v-list>
                                                </v-menu>
                                            </div>
                                        </v-col>
                                    </v-row>



                                    <v-chip class="ma-2 text-right" label v-if="chart.type === 'LINE'"
                                            color="primary">
                                        <v-icon left>
                                            mdi-chart-line
                                        </v-icon> {{chart.type}}
                                    </v-chip>

                                    <v-chip class="ma-2 text-right" label v-if="chart.type === 'WORDCLOUD'"
                                            color="green">
                                        <v-icon left>
                                            mdi-alpha-w-box
                                        </v-icon>{{chart.type}}
                                    </v-chip>

                                    <v-chip class="ma-2 text-right" label v-if="chart.type === 'PIE'"
                                            color="red">
                                        <v-icon left>
                                            mdi-chart-arc
                                        </v-icon>{{chart.type}}
                                    </v-chip>

                                    <v-chip class="ma-2 text-right" label v-if="chart.type === 'TABLE'"
                                            color="default">
                                        <v-icon left>
                                            mdi-table
                                        </v-icon> {{chart.type}}
                                    </v-chip>


                                </v-card>
                            </v-col>
                        </v-row>

                        <div class="text-center pb-3" v-if="templateChartTotalPages > 0">
                            <v-pagination v-model="templateChartPageNo"
                                          :length="templateChartTotalPages"
                                          circle></v-pagination>
                        </div>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-container>
</template>

<script>
    import ChartService from "../../services/chartService"
    import config from '../../../public/okta.config.json';
    export default {
        name: 'MyCharts',
        data: function () {
            return {
                isAdmin: false,
                isBusy: false,
                accessToken: "",
                tab: null,
                items: [
                    'My Charts', 'Template Charts',
                ],
                myCharts: [],
                templateCharts: [],
                //My Charts Search
                myChartSearchText: "",
                myChartPageNo: 1,
                myChartPageSize: 10,
                myChartTotalItems: 0,
                myChartSearchTimer: null,
                //Template Charts Search
                templateChartSearchText: "",
                templateChartPageNo: 1,
                templateChartPageSize: 10,
                templateChartTotalItems: 0,
                templateChartSearchTimer: null,
            }
        },
        components: {

        },
        watch: {
            deep: true,
            immediate: true,
            //my charts
            myChartPageSize: function () {
                this.getMyCharts();
            },
            myChartPageNo: function () {
                this.getMyCharts();
            },
            myChartSearchText: function () {
                let self = this;
                clearTimeout(this.myChartSearchTimer);
                this.myChartSearchTimer = setTimeout(function () {
                    self.getMyCharts();
                }, 1000);
            },
            //template chart
            templateChartPageSize: function () {
                this.getTemplateCharts();
            },
            templateChartPageNo: function () {
                this.getTemplateCharts();
            },
            templateChartSearchText: function () {
                let self = this;
                clearTimeout(this.templateChartSearchTimer);
                this.templateChartSearchTimer = setTimeout(function () {
                    self.getTemplateCharts();
                }, 1000);
            },
        },
        computed: {
            myChartTotalPages() {
                return Math.ceil(this.myChartTotalItems / this.myChartPageSize);
            },
            templateChartTotalPages() {
                return Math.ceil(this.templateChartTotalItems / this.templateChartPageSize);
            }
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                var user = await this.$auth.getUser();
                this.isAdmin = user.groups.includes(config.adminGroup);

                await this.getCharts();
            },
            async getCharts() {
                await this.getMyCharts();
                await this.getTemplateCharts();
            },
            editChart(chart) {
                this.$router.push({ name: 'ChartBuilder', params: { id: chart.id, type: chart.type, action: "edit" } });
            },
            cloneChart(chart) {
                this.$router.push({ name: 'ChartBuilder', params: { id: chart.id, type: chart.type, action: "clone" } });
            },
            async getMyCharts() {
                this.isBusy = true;

                let myChartResult = await ChartService.searchMyCharts(this.myChartSearchText, this.myChartPageNo, this.myChartPageSize, this.accessToken);

                this.myChartTotalItems = myChartResult.count;
                this.myCharts = myChartResult.data;

                this.isBusy = false;
            },
            async getTemplateCharts() {
                this.isBusy = true;

                let templateChartResult = await ChartService.searchTemplateCharts(this.templateChartSearchText, this.templateChartPageNo, this.templateChartPageSize, this.accessToken);

                this.templateChartTotalItems = templateChartResult.count;
                this.templateCharts = templateChartResult.data;

                this.isBusy = false;
            }
        },
        created() {
            this.setup();
        },
        mounted() {

        },
    }
</script>
